import './App.css';
import { Context, createContext, useEffect, useRef, useState } from 'react';
import { CategoryInfo, emptyState, useCategories } from './util/use-categories';
import { counterSubscribe, counterUnsubscribe } from './util/api';
import { debounce } from './util/misc';
import TemplateComponent from './components/templates';
import { Suspense } from 'react';
import { YandexIndexerContext, useYandexIndexer, emptyIndexerContext } from './hooks/yandex-indexer'

export const CategoriesContext: Context<CategoryInfo> = createContext(emptyState as CategoryInfo);
export const IndexerContext: Context<YandexIndexerContext> = createContext(emptyIndexerContext);

function App() {
    const [hasPendingRequests, setHasPendingRequests] = useState(true);
    const indexerContext = useYandexIndexer(true);
    const pendingRef = useRef(hasPendingRequests);
    pendingRef.current = hasPendingRequests;
    // const { loaded, setUnloaded } = indexerContext;
    useEffect(() => {
        // если ничего не грузилось и начало, то ставим прелоадер сразу
        // в остальных случаях с небольшим дебаунсом
        // чтобы не мигал при поочередных запросах
        const debounced = debounce((k: number) => {
            setHasPendingRequests(k > 0);
        }, 100);
        
        const sub = (k: number) => {
            if (k > 0 && !pendingRef.current) {
                setHasPendingRequests(true);
            } else {
                debounced(k);
            }
        };
        counterSubscribe(sub);
        return () => counterUnsubscribe(sub);
    }, [hasPendingRequests]);
    // useEffect(() => {
    //     const debouncedLoaded = debounce(() => {
    //         loaded();
    //     }, 1000);
    //     if (!hasPendingRequests) {
    //         debouncedLoaded();
    //     } else {
    //         setUnloaded();
    //     }
    // }, [hasPendingRequests, setUnloaded, loaded])
    const categories = useCategories();

    return (
        <IndexerContext.Provider value={indexerContext}>
            <CategoriesContext.Provider value={categories}>
                <Suspense
                    fallback={
                        <div className="preloader">
                            <span className="spinner" />
                        </div>
                    }
                >
                    <TemplateComponent hasPendingRequests={hasPendingRequests} />
                </Suspense>
            </CategoriesContext.Provider>
        </IndexerContext.Provider>
    );
}

export default App;
